import React, { Component } from 'react'
import { graphql } from 'gatsby'

import Seo from '../components/seo'

import RenderBlock from '../utils/render-block'

class PageTemplate extends Component {

  render() {
    const { wpPage } = this.props.data

    return (
      <>
        <Seo bodyClass={`page-template page-template--${wpPage.slug}`} {...wpPage.seo} />
        {wpPage.acf.contentBlocks?.map((el, i) => RenderBlock(el.fieldGroupName?.replace('page_Acf_ContentBlocks_', ''), el, i))}
      </>
    )
  }
}

export const pageQuery = graphql`
  query ($id: String!) {
    wpPage(id: {eq: $id}) {
      title
      slug
      uri
      seo {
        ...WpSeo
      }
      acf {
        contentBlocks {
          ... on WpPage_Acf_ContentBlocks_Landing {
            fieldGroupName
            video
            mobileVideo
          }
          ... on WpPage_Acf_ContentBlocks_Home {
            fieldGroupName
            menu {
              description
              link
              text
            }
            gallery {
              altText
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                  )
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_Projects {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_Media {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_ThankYou {
            content
            fieldGroupName
            title
            image {
              altText
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    width: 1400
                  )
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_ContactDetails {
            address
            fieldGroupName
            email {
              title
              url
            }
            phone {
              title
              url
            }
            socials {
              link {
                title
                url
              }
            }
            title
          }
          ... on WpPage_Acf_ContentBlocks_ContactMap {
            fieldGroupName
            googleMap {
              latitude
              longitude
            }
          }
          ... on WpPage_Acf_ContentBlocks_ContactForm {
            content
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_Partners {
            content
            fieldGroupName
            items {
              link
              title
            }
            title
            hashId
          }
          ... on WpPage_Acf_ContentBlocks_LargeContent {
            content
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_LatestMedia {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_PageLinks {
            fieldGroupName
            leftLink {
              title
              url
            }
            rightLink {
              title
              url
            }
          }
          ... on WpPage_Acf_ContentBlocks_FourColumnContent {
            fieldGroupName
            columns {
              content
              title
            }
          }
          ... on WpPage_Acf_ContentBlocks_Image {
            fieldGroupName
            portrait
            image {
              altText
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    width: 1400
                  )
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_TitleContentCta {
            content
            fieldGroupName
            largeText
            link {
              title
              url
            }
            title
          }
          ... on WpPage_Acf_ContentBlocks_TitleContent {
            content
            fieldGroupName
            title
            hashId
          }
          ... on WpPage_Acf_ContentBlocks_PageHeader {
            fieldGroupName
            title
            image {
              altText
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    width: 1400
                  )
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default PageTemplate;
